import { useCallback, useState } from "react";
import { formatDate, basePath } from "../Constants/constant";
import { useEffect } from "react";
import axios from "axios";
import TooltipComponent from "../Usables/TooltipComponent";
import InputField from "../Usables/InputField";
import { ClearButton, FilterButton } from "../Usables/Buttons";
import Pagination from "../Usables/Pagination";
import NoRecords from "../Usables/NoRecords";
import Loader from "../Usables/Loader";


const WorkAllowcation = () => {
    const [filterData, setFilterData] = useState({
        selectedDate: "",
        recruiterStatus: 1,
        orderBy: "assigned_at",
        orderDirection: "DESC"
    });
    const [recruiterWiseData, setRecruiterWiseData] = useState([]);
    const [date, setDate] = useState(new Date());
    const [loading, setLoading] = useState(false);
    const [loadingFilter, setLoadingFilter] = useState(false);
    const [ischanged, setIschanged] = useState({getListChanged: false,});
    const [pagination, setPagination] = useState({page: 1, totalRecords: "", totalPages: "", limit: 10,});

    const handleSort = (columnName) => {
        if (filterData?.orderBy === columnName) {
            if (filterData?.orderDirection === "DESC") {
                setFilterData({ ...filterData, orderBy: columnName, orderDirection: 'ASC' });
            }
            else {
                setFilterData({ ...filterData, orderBy: columnName, orderDirection: 'DESC' });
            }
        }
        else {
            setFilterData({ ...filterData, orderBy: columnName, orderDirection: 'ASC' });
        }
    }

    const getList = useCallback(async () => {
        try {
            const response = await axios.get(`${basePath}/getassignrecruiterlog?limit=${pagination?.limit}&page=${pagination?.page}&id=${localStorage.getItem("userId")}&filter=${JSON.stringify(filterData)}`);
            console.log("getList ~ response", response.data);
            setRecruiterWiseData(response.data?.groupped_report);
            setPagination({
                ...pagination,
                totalPages: response?.data?.pages,
                totalRecords: response?.data?.totalRecords
            });
            setDate(filterData?.selectedDate || new Date());
            setLoading(false);
            setLoadingFilter(false);
        } catch (error) {
            console.log(error);
            setLoading(false);
            setLoadingFilter(false);
        }
       
    },[filterData, pagination]);

    useEffect(() => {
        setLoading("1");
        getList();
    },[]);

    useEffect(() => {
        if(ischanged?.getListChanged) {
            getList();
            setIschanged({...ischanged, getListChanged: false});
        }
    },[ischanged?.getListChanged]);

    const handleChangeFilter = (e)=> {
        const {value, name} = e.target;
        setFilterData({...filterData, [name]: value, recruiterStatus: "All",});
    }

    const handleFilter = useCallback(()=>{ 
        setLoadingFilter("1");
        getList();
    },[getList]);
    
    const handleClear = useCallback(()=> {
        setLoadingFilter("2");
        setFilterData({
            selectedDate: "",
            recruiterStatus: 1,
            orderBy: "assigned_at",
            orderDirection: "DESC"
        });
        setIschanged({...ischanged, getListChanged:true});
    },[ischanged]);

    const handleLimit = (e)=> {
        setPagination({...pagination, limit: e.target.value});
        setIschanged({...ischanged, getListChanged: true})
    }
    const handlePrev = (e)=> {
        if (pagination?.page > 1) {
            setPagination({...pagination, page: pagination?.page - 1});
            setIschanged({...ischanged, getListChanged: true})
        }
    }
    const handleNext = (e)=> {
        if (pagination?.totalPages > pagination?.page) {
            setPagination({...pagination, page: pagination?.page + 1});
            setIschanged({...ischanged, getListChanged: true})
        }
    }

    return(
        <div className='relative grayBlurShadow bg-white rounded-3xl overf low-hidden mt-4 overflow-hidden'>
            <div className=" absolute left-4 top-3 flex items-center gap-3">
                <InputField  id="selectedDate" name="selectedDate" type="date"
                disabled={loading === '1'}
                value={filterData?.selectedDate}
                onChange={handleChangeFilter}
                />
                <FilterButton onClick={handleFilter} disabled={!filterData?.selectedDate} />
                <ClearButton onClick={handleClear} disabled={!filterData?.selectedDate} />
            </div>
            <h1 className="text-2xl font-semibold text-gray-800 tracking-wide pt-5 px-5">Work Allocation - {`${loadingFilter ? "Loading..." : formatDate(date)}`}</h1>
           {
            loading === "1" ?
                <Loader/> :
                Array.isArray(recruiterWiseData) && recruiterWiseData?.length >= 1 ?
                <div className='tableWrapper'>
                    <div className='tableBody'>
                        <table className='w-full table-fixed border-collapse'>
                        <thead className='tableHead'>
                            <tr className='bg-gray-200'>
                            <th className='whitespace-nowrap cursor-pointer'>Recruiter Name</th>
                            <th className='whitespace-nowrap cursor-pointer w-[27%]' onClick={() => handleSort("position")}>Position Name</th>
                            <th className='whitespace-nowrap text-center'>Days Worked</th>
                            <th className='whitespace-nowrap text-center'>Position Rec Date</th>
                            <th className='whitespace-nowrap text-center'>Position CTC (LPA)</th>
                            <th className='whitespace-nowrap text-center'>Sent To Client</th>
                            </tr>
                        </thead>
                        <tbody className='tableBody'>
                            {Array.isArray(recruiterWiseData) && recruiterWiseData.map((val, idx) => {
                            return (
                                <tr key={`${val.recruiter_id}`}
                                className={`font-semibold text-sm ${idx % 2 === 1 ? 'bg-gray-100' : 'bg-white'}`}
                                >
                                <td  className='text-left'>
                                    {/* {idx === 0 && ( */}
                                    <TooltipComponent name={val.recruiter_name}>
                                        <span className='line-clamp-1 w-full text-ellipsis text-start cursor-default'>
                                            {idx+1}. {val.recruiter_name}
                                        </span>
                                    </TooltipComponent>
                                    {/* )} */}
                                </td>
                                <td>
                                    {val.positions.map((item, index) => {
                                    return (
                                        <div className={`flex gap-2 ${index > 0 && index < val?.positions?.length-1 ? "my-2" : ""}`}>
                                            <span>{index + 1}.</span>
                                            <div>
                                                <span className='line-clamp-1 w-full text-ellipsis text-start'>{item?.position_title}</span>
                                                <div className='text-sm line-clamp-1 text-ellipsis text-start text-gray-400'>{item?.company_name}</div>
                                            </div>
                                        </div>
                                        )})}
                                    </td>
                                    <td>
                                    {val.positions.map((item, index) => { return (
                                        <div className={`flex items-center justify-center h-10 gap-2 ${index > 0 && index < val?.positions?.length-1 ? "my-2" : ""}`}>{item.total_days_worked || 0}</div> )})}
                                </td>
                                    <td>
                                    {val.positions.map((item, index) => { return (
                                        <div className={`flex items-center justify-center h-10 gap-2 ${index > 0 && index < val?.positions?.length-1 ? "my-2" : ""}`}>{item.created_at && formatDate(item.created_at)}</div> )})}
                                </td>
                                    <td>
                                    {val.positions.map((item, index) => { return (
                                        <div className={`flex items-center justify-center h-10 gap-2 ${index > 0 && index < val?.positions?.length-1 ? "my-2" : ""}`}>{item.min_ctc} - {item.max_ctc} <span className='text-green-500'>{item.currency_code || ''}</span></div>)})}
                                </td>
                                    <td>
                                    {val.positions.map((item, index) => { return (
                                        <div className={`flex items-center justify-center h-10 gap-2 ${index > 0 && index < val?.positions?.length-1 ? "my-2" : ""}`}>{item.candidate_count || 0}</div> )})}
                                </td>
                                </tr>
                            );
                            })}
                        </tbody>
                        </table>
                    </div>
                    <Pagination onLimitChange={handleLimit} onPrevChange={handlePrev} onNextChange={handleNext}
                    limit={pagination?.limit} totalRecords={pagination?.totalRecords} allPages={pagination?.totalPages} page={pagination?.page}
                    disabledPrev={pagination?.page === 1} disabledNext={pagination?.page === pagination?.totalPages}
                    />
                </div> :
                <NoRecords/>
            }
        </div>
    )
}
export default WorkAllowcation;